/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type NftStatus_enum = "Auction" | "Listed" | "Owned" | "%future added value";
export type NftPrice_MetadataAccount = {
    readonly id: string;
    readonly nft: {
        readonly id: string;
        readonly price: unknown | null;
        readonly status: NftStatus_enum;
    };
    readonly " $refType": "NftPrice_MetadataAccount";
};
export type NftPrice_MetadataAccount$data = NftPrice_MetadataAccount;
export type NftPrice_MetadataAccount$key = {
    readonly " $data"?: NftPrice_MetadataAccount$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"NftPrice_MetadataAccount">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPrice_MetadataAccount",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NftExpress",
      "kind": "LinkedField",
      "name": "nft",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "price",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MetadataAccount",
  "abstractKey": null
};
})();
(node as any).hash = 'ea63a64d34eec65fbad1a4466fd7920a';
export default node;
